import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import Button from './Button';
import Dialog from './Dialog';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  severity?: 'warning' | 'error' | 'info';
  isActioning?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isActioning = false,
}) => {

  return (
    <Dialog
      open={open}
      maxWidth="md"
      onClose={onClose}
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>{cancelText}</Button>
        <Button variant="contained" onClick={onConfirm} autoFocus disabled={isActioning} isLoading={isActioning}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal; 